import { forwardRef, useEffect, useImperativeHandle, useState, useRef, useContext } from "react";
import "./BonusPopup.scss";
import { MyContextHoldem } from '../CasinoHoldem';

// ─── Flying Gold Chip ───────────────────────────────────────────────
function FlyingChip({ index, delay }) {
  const [phase, setPhase] = useState("idle");

  useEffect(() => {
    const t0 = setTimeout(() => setPhase("blast"), delay + 60);
    const t1 = setTimeout(() => setPhase("fly"),   delay + 380);
    const t2 = setTimeout(() => setPhase("done"),  delay + 900);
    return () => [t0, t1, t2].forEach(clearTimeout);
  }, []);

  if (phase === "done") return null;

  return (
    <div
      className={`flying-chip flying-chip--${phase}`}
      style={{ "--i": index }}
    >
      <div className="flying-chip__inner">GOLD</div>
    </div>
  );
}

// ─── Bonus Popup ─────────────────────────────────────────────────────
const BonusPopup = forwardRef(({
  bonusAmount,
  onClose,
  isbonuspopup,
  targetX,
  targetY,
  winPanelX,
  winPanelY,
}, ref) => {

  const { bonuspopup, setbonuspopup, winAmount, setWinAmount } = useContext(MyContextHoldem);

  const [showText,      setShowText]      = useState(false);
  const [showAmt,       setShowAmt]       = useState(false);
  const [chips,         setChips]         = useState([]);
  const [flying,        setFlying]        = useState(false);
  const [goldcoinanim,  setGoldcoinanim]  = useState(false);
  const amountRef = useRef(null);

  useEffect(() => {
    setChips(Array.from({ length: 22 }, (_, i) => ({ id: i, delay: i * 50 })));
    const t1 = setTimeout(() => setShowText(true), 350);
    const t2 = setTimeout(() => setShowAmt(true),  650);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  useImperativeHandle(ref, () => ({
    reset: () => {
      setShowText(false);
      setShowAmt(false);
      setFlying(false);
      setChips([]);
      setGoldcoinanim(false);
    },
  }));

  const handleCollect = () => {
    setWinAmount(bonusAmount);
    setGoldcoinanim(true);
    setFlying(true);
    setTimeout(() => {
      onClose?.();
      setbonuspopup(false)
    }, 1550);
  };

  return (
    <>
      {/* Backdrop */}
      <div className="bonus-backdrop" />

      {/* Flying Chips — purely CSS positioned via SCSS + media queries */}
      {goldcoinanim && (
        <div className="flying-chips-container">
          {chips.map((c) => (
            <FlyingChip key={c.id} index={c.id} delay={c.delay} />
          ))}
        </div>
      )}

      {/* Flying Amount */}
      {flying && (
        <div className="flying-amount">
          +${bonusAmount}
        </div>
      )}

      {/* Popup Card */}
      {isbonuspopup && (
        <div className="bonus-popup">
          <div className="bonus-popup__topline" />

          <span className="bonus-popup__star bonus-popup__star--right">✦</span>
          <span className="bonus-popup__star bonus-popup__star--left">✦</span>

          {Array.from({ length: 12 }, (_, i) => (
            <div
              key={i}
              className={`confetti-dot ${showText ? "confetti-dot--fall" : ""}`}
              style={{
                right: `${2 + i * 6}%`,
                left: "auto",
                animationDelay: `${0.08 + i * 0.04}s`,
                width:  i % 3 === 0 ? 7 : 5,
                height: i % 3 === 0 ? 7 : 5,
                borderRadius: i % 2 === 0 ? "50%" : 2,
                background: ["#fbbf24", "#fef08a", "#f59e0b", "#fff"][i % 4],
              }}
            />
          ))}

          <div className="bonus-popup__crown">👑</div>

          <div className={`bonus-popup__label ${showText ? "bonus-popup__label--visible" : ""}`}>
            ✦ You Won ✦
          </div>

          <div className={`bonus-popup__title ${showText ? "bonus-popup__title--visible" : ""}`}>
            BONUS!
          </div>

          <div className="bonus-popup__divider" />

          <div className={`bonus-popup__amount-block ${showAmt ? "bonus-popup__amount-block--visible" : ""}`}>
            {/* <div className="bonus-popup__payout-label">BONUS PAYOUT</div> */}

            <div className="bonus-popup__amount" ref={amountRef}>
              {bonusAmount}
            </div>

            <div className="bonus-popup__chips">
              {[0, 1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className={`mini-chip ${showAmt ? "mini-chip--pop" : ""}`}
                  style={{ animationDelay: `${0.55 + i * 0.08}s` }}
                />
              ))}
            </div>

            <div className="bonus-popup__coins">
              {["🪙", "🪙", "🪙"].map((c, i) => (
                <span
                  key={i}
                  className={`coin-emoji ${showAmt ? "coin-emoji--pop" : ""}`}
                  style={{ animationDelay: `${0.75 + i * 0.1}s` }}
                >
                  {c}
                </span>
              ))}
            </div>
          </div>

          <button
            className={`bonus-popup__btn ${showAmt ? "bonus-popup__btn--visible" : ""}`}
            onClick={handleCollect}
          >
            Collect Bonus
          </button>

          <div className="bonus-popup__bottomline" />
        </div>
      )}
    </>
  );
});

BonusPopup.displayName = "BonusPopup";
export default BonusPopup;
